function escapeHtml(s: string) {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function renderMarkdown(md: string): string {
  if (!md) return "";
  const fences: string[] = [];
  md = md.replace(/```([\s\S]*?)```/g, (_m, code) => {
    const idx = fences.push(`<pre><code>${escapeHtml(code)}</code></pre>`) - 1;
    return `§§FENCE_${idx}§§`;
  });

  let html = escapeHtml(md);

  html = html
    .replace(/^###### (.*)$/gm, "<h6>$1</h6>")
    .replace(/^##### (.*)$/gm, "<h5>$1</h5>")
    .replace(/^#### (.*)$/gm, "<h4>$1</h4>")
    .replace(/^### (.*)$/gm, "<h3>$1</h3>")
    .replace(/^## (.*)$/gm, "<h2>$1</h2>")
    .replace(/^# (.*)$/gm, "<h1>$1</h1>");

  html = html.replace(/^> (.*)$/gm, "<blockquote>$1</blockquote>");

  html = html
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/__(.+?)__/g, "<strong>$1</strong>")
    .replace(/(^|[^*])\*(?!\s)(.+?)\*(?!\*)/g, "$1<em>$2</em>")
    .replace(/(^|[^_])_(?!\s)(.+?)_(?!_)/g, "$1<em>$2</em>");

  html = html.replace(/`([^`]+)`/g, (_m, code) => `<code>${escapeHtml(code)}</code>`);

  html = html.replace(
    /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
    `<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>`
  );

  html = html
    .replace(/^(?:\s*[-*]\s+.+\n?)+/gm, (block) => {
      const items = block
        .trim()
        .split(/\n/)
        .map((line) => line.replace(/^\s*[-*]\s+(.+)$/, "<li>$1</li>"))
        .join("");
      return `<ul>${items}</ul>\n`;
    })
    .replace(/^(?:\s*\d+\.\s+.+\n?)+/gm, (block) => {
      const items = block
        .trim()
        .split(/\n/)
        .map((line) => line.replace(/^\s*\d+\.\s+(.+)$/, "<li>$1</li>"))
        .join("");
      return `<ol>${items}</ol>\n`;
    });

  html = html
    .split(/\n{2,}/)
    .map((chunk) => {
      if (/^\s*<(h\d|ul|ol|pre|blockquote)/.test(chunk)) return chunk;
      if (!chunk.trim()) return "";
      return `<p>${chunk.replace(/\n/g, "<br/>")}</p>`;
    })
    .join("");

  html = html.replace(/§§FENCE_(\d+)§§/g, (_m, i) => fences[Number(i)] || "");
  return html;
}
